import { useMutation, useQuery } from "@tanstack/react-query"
import { getProgramById, updateProgramByUpdateProgramAdminRequest } from "../../../../../service/program";
import { Navigate } from "react-router-dom";

const useUpdateProgramByUpdateProgramAdminRequest = () => {
    const mutation = useMutation({
        mutationFn: updateProgramByUpdateProgramAdminRequest,
        onSuccess: () => <Navigate to={`/wellness-program/program`} replace />,
    })

    return mutation;
}

const useGetProgramById = (id: number, programField?: IProgramField) => {
    const query = useQuery({
        queryKey: ['getProgramById', id],
        queryFn: () => getProgramById(id, programField),
        enabled: !!id,
        select: res => res.data.data.getProgramById,
    });

    return query;
}



export { useGetProgramById, useUpdateProgramByUpdateProgramAdminRequest };